// extracted by mini-css-extract-plugin
module.exports = {"collapse":"PromotionTerms_collapse__1ybjz","collapseTitle":"PromotionTerms_collapseTitle__GGOnd","collapseDescription":"PromotionTerms_collapseDescription__2Go8s"};